<template>
  <el-dialog
    title="正在答辩"
    :visible.sync="visible"
    width="90%"
    :before-close="handleClose"
  >
    <div class="xuanke_box">
      <div class="shijuanxx">
        <h2>{{ thesis.name }}</h2>
        <p>
          (毕业考核课程：{{ `${thesis.courseCode}-${thesis.courseName}` }}，指导老师：{{
            db.thesisBatchName
          }})
        </p>
        <p>
          考生姓名：<span>{{ db.studentName }}</span
          >&nbsp;&nbsp; 准考证号：<span>{{ db.candidateNumber }}</span
          >&nbsp;&nbsp; 身份证号：<span>{{ db.studentNumber }}</span>
        </p>
      </div>
      <div class="shiti">
        <div class="shitilx" style="background: #eee">
          论文答辩照片
          <template v-if="!dbAtt.length">（暂未上传）</template>
        </div>
        <div class="tm_paper_section" id="picListDiv">
          <div v-for="(pic, i) in dbAtt" :key="i">
            <fieldset>
              <legend style="font-size: 14px">
                上传的答辩照片<span>{{ i + 1 }}</span
                >:
              </legend>
              <div style="text-align: center">
                <el-button
                  size="mini"
                  class="normal_btn"
                  type="primary"
                  @click="showOrHide(pic, i)"
                >
                  {{ pic.show ? "展开" : "折叠" }}
                </el-button>
                <el-button
                  size="mini"
                  class="normal_btn"
                  type="primary"
                  @click="removeAtt(pic.id)"
                >
                  删除
                </el-button>
                <el-button
                  size="mini"
                  class="normal_btn"
                  type="primary"
                  @click="openInNewWin(pic.attPath)"
                >
                  新窗口查看
                </el-button>
                <div style="margin-top: 5px" v-show="!pic.show">
                  <XwImg
                    :src="pic.attPath"
                    style="max-width: 600px"
                    curRotateIndex="0"
                    id="img_${pic.id}"
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="visible = false"
        >关闭</el-button
      >
      <el-button
        size="mini"
        type="primary"
        @click="tm_uploader"
        v-if="db.status == 0 || db.status == 1"
        >上传</el-button
      >
      <Upload
        style="display: none"
        @success="UploadChange"
         accept=".jpg,.png,.jpeg"
        :size="1024 * 1024"
        id="tm_uploader_Upload"
      />
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {
    XwImg: () => import("@/components/XwImg.vue"),
  },
  data() {
    return {
      visible: false,
      thesis: {},
      dbAtt: [],
      db: {},
      d: {},
    };
  },
  methods: {
    async open(res) {
      await this.getInfo(res);
      this.visible = true;
    },
    getInfo(id) {
      this.$http
        .post("/student/thesis2/thesisOnlineDetail", { id })
        .then(res => {
          this.d = res;
          this.dbAtt = res.dbAtt;
          this.thesis = res.thesis;
          this.db = res;
        });
    },
    handleClose() {
      this.visible = false;
      this.config = {};
    },
    showOrHide(pic, i) {
      this.$set(pic, "show", !pic.show);
    },
    UploadChange(res) {
      const _t = this;
      if (res.code === 0) {
        const params = {
          thesisId: this.db.thesisId,
          attPath: res.data.url,
        };
        _t.$http.post("/student/thesis2/saveAtt", params).then(res => {
          if (res) {
            _t.getInfo(_t.db.thesisId);
          }
        });
      }
    },
    tm_uploader(){
      document
          .getElementById("tm_uploader_Upload" )
          .getElementsByClassName("el-upload__input")[0]
          .click();
    },
    removeAtt(attId) {
      const _t = this;
      this.$confirm("确定删除论文答辩照片？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          _t.$http.post("/student/thesis2/removeAtt", { attId }).then(res => {
            if (res) {
              _t.getInfo(_t.db.thesisId);
            }
          });
        })
        .catch(() => {});
    },
    openInNewWin(url) {
      window.open(url);
    },
  },
};
</script>

<style scoped>
blockquote, body, dd, div, dl, dt, fieldset, form, h1, h2, h3, h4, h5, h6, img, input, li, ol, p, pre, td, th, ul,hr,legend {
    margin: 0;
    padding: 0;
    
}

</style>
